import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BRAND, getThemeColors } from "./themes";
import { API_BASE_URL } from "./config";

export default function ScenarioList({ theme, apiBase = API_BASE_URL, onSelect }) {
  const navigate = useNavigate();
  const [scenarios, setScenarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const themeColors = getThemeColors(theme);

  useEffect(() => {
    const fetchScenarios = async () => {
      try {
       const username = localStorage.getItem("username");
       const res = await fetch(`${apiBase}/scenarios`, {
           method: "POST",
           credentials: "include",
           headers: { "Content-Type": "application/json" },
           body: JSON.stringify({ username: localStorage.getItem("username") })
       });
       if (res.status === 401) {
            navigate("/login");
            return;
          };
        const data = await res.json();
        setScenarios(data.scenarios);
      } catch (err) {
        console.error("Error fetching scenarios:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchScenarios();
  }, [apiBase]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 40, color: themeColors.text }}>
        <div style={{ marginTop: 12 }}>Loading scenarios...</div>
      </div>
    );
  }

  return (
      <div className="custom-scrollbar" style={{
        maxHeight: '50vh',
        overflowY: 'auto',
        padding: 4,
      }}>
        <div
          onClick={() => onSelect(null)}
          style={{
            padding: 10,
            margin: 4,
            background: themeColors.primary,
            color: '#fff',
            cursor: 'pointer',
            fontWeight: 600,
            fontSize: 13,
            borderRadius: 6,
          }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '0.9'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
        >
          🎲 Random Scenario
        </div>

        {scenarios.map((scenario, idx) => (
          <div
            key={idx}
            onClick={() => onSelect(scenario.idx)}
            style={{
              padding: 10,
              margin: 4,
              background: theme === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)',
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: 13,
              color: themeColors.text,
              transition: 'background 0.15s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = theme === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = theme === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)';
            }}
          >
            {idx + 1}: {scenario.name} - {scenario.scenario_name}
          </div>
        ))}
      </div>
    );
}